import { Button, Stack } from '@optimus-web/core';
import { createZodFormResolver, lt, showSuccessAlert, Form } from '@mews/framework';
import { PaymentsPolicyConfigurationFormValues, paymentsConfigurationFormSchema } from '../schema';
import { PaymentsConfigurationFieldName } from '../types';
import { useUpdatePaymentsConfiguration } from '../../../mutations';
import { useGetPaymentsConfiguration } from '../../../queries';
import { PaymentsConfigurationFormFields } from './PaymentsConfigurationFormFields';

export const PaymentsConfigurationForm = () => {
    const {
        data: { chainId, isAdminInAllEnterprisesInChain, isCardSharingEnabled, enterprises, retentionPolicyDays },
    } = useGetPaymentsConfiguration();
    const { mutate, isPending } = useUpdatePaymentsConfiguration();

    const formValues: PaymentsPolicyConfigurationFormValues = {
        [PaymentsConfigurationFieldName.IsCardSharingEnabled]: isCardSharingEnabled,
        [PaymentsConfigurationFieldName.RetentionPolicyDays]: retentionPolicyDays,
    };
    const resolver = createZodFormResolver<PaymentsPolicyConfigurationFormValues>(paymentsConfigurationFormSchema);

    const handleSubmit = (values: PaymentsPolicyConfigurationFormValues) => {
        mutate(
            {
                chainId,
                ...values,
            },
            {
                onSuccess: () => {
                    showSuccessAlert({ description: lt('PaymentsConfigurationSaveSuccessMessage') });
                },
            }
        );
    };

    return (
        <Form onSubmit={handleSubmit} values={formValues} resolver={resolver}>
            <Stack vertical spacing="300">
                <PaymentsConfigurationFormFields
                    enterprises={enterprises}
                    isAdminInAllEnterprisesInChain={isAdminInAllEnterprisesInChain}
                />
                <Stack alignment="end">
                    <Button variant="primary" type="submit" loading={isPending}>
                        {lt('Save')}
                    </Button>
                </Stack>
            </Stack>
        </Form>
    );
};
